import React from 'react';

import { ShapeMultipleIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';

import MarkupsEntityBlock from './MarkupsEntityBlock';
import MarkupsEntityMenuItem from './MarkupsEntityMenuItem';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { services } from '../helpers/sdkServicesMarkup';
import { chunk } from '../helpers/utils';
import { DocumentEntity, Document } from '../types/types';

const markupsOnDocumentsPlugin: ReferencePickerPlugin<DocumentEntity> = {
  metadata: {
    domain: 'autodesk-construction-markup',
    type: 'markupdocument',
  },
  renderIcon: (p) => <ShapeMultipleIcon {...p} />,
  PluralText: ({ lowerCase }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const result = T.translate('MARKUPS');
    return lowerCase && typeof result === 'string'
      ? result.toLowerCase()
      : result;
  },
  // Get linked documents
  getEntitiesByIds: async ({ projectId, ids }) => {
    const data: DocumentEntity[] = [];
    await chunk(ids, 50).reduce((promise: Promise<any>, documentUrns) => {
      return promise.then(() =>
        Promise.all(
          documentUrns.map((documentUrn) =>
            // Fetch the document so we can use the version uid to fetch annotations
            services.Projects.getDocument(projectId, documentUrn).then(
              (document: Document) => {
                // Fetch annotations
                data.push({
                  id: documentUrn,
                  name: document.name,
                  entityId: encodeURIComponent(documentUrn),
                  versionId: document.version.id,
                });
              },
            ),
          ),
        ),
      );
    }, Promise.resolve());
    return { data };
  },
  EntityBlock: MarkupsEntityBlock,
  EntityMenuItem: MarkupsEntityMenuItem,
};

export default markupsOnDocumentsPlugin;
